import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";
import { normalizeLanguage } from "../../services/language";
import ModernSidebar, { useModernRouteActions } from "../../components/lobby/ModernSidebar";
import "../../components/lobby/lobbyModern.css";
import "./premium.css";

// Membresía Premium: 2 USD al mes por PayPal (la misma cuenta que «Haz una contribución»
// de Caissa). Por ahora el administrador activa Premium a mano en Usuarios registrados
// cuando llega el pago; la activación automática necesita una suscripción de PayPal.
export const PREMIUM_PRICE_USD = 2;
export const PREMIUM_PAYPAL_URL = `https://paypal.me/muinoxima/${PREMIUM_PRICE_USD}USD`;
export const PREMIUM_SUPPORT = { mail: "info@juegoxima.com", wa: "18647536014", waShow: "+1 864 753 6014" };

const BENEFITS = [
  ["🧠", "Análisis sin límite", "Analiza todas las partidas que quieras con el bot. Sin Premium tienes 3 análisis nuevos al día."],
  ["🎬", "Videos sin límite", "Descarga en video MP4 todas tus partidas para compartirlas. Sin Premium, 1 video al día."],
  ["💚", "Apoyas a XIMA", "Tu membresía nos ayuda a seguir creando juegos, torneos y mejoras para todos."],
];

const STEPS = [
  ["Paga con PayPal", `Pulsa «Pagar con PayPal» y envía ${PREMIUM_PRICE_USD} USD (puedes pagar con tarjeta, no hace falta cuenta).`],
  ["Avísanos", "Escríbenos por WhatsApp o correo con tu nombre de usuario de XIMA."],
  ["Listo", "Activamos tu Premium en tu cuenta. Cada mes que pagues, sigues siendo Premium."],
];

const Premium = () => {
  const outletContext = useOutletContext() || {};
  const language = normalizeLanguage(outletContext.language);
  const { user } = useAuth() || {};
  const routeActions = useModernRouteActions();
  const [access, setAccess] = useState(null);

  // Igual que el Historial: se esconde el menú antiguo y queda solo el del diseño Clásico.
  useEffect(() => {
    document.body.classList.add("xima-lobby-modern-active");
    return () => document.body.classList.remove("xima-lobby-modern-active");
  }, []);

  useEffect(() => {
    let cancelled = false;
    axios
      .get("/replays/access")
      .then((response) => {
        if (!cancelled) setAccess(response?.data?.access || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const userName = user?.username || user?.loginIdentifier || user?.email || "";
  const note = `Hola, pagué la membresía Premium de XIMA (${PREMIUM_PRICE_USD} USD/mes). Mi usuario es: ${userName}`;
  const waUrl = `https://wa.me/${PREMIUM_SUPPORT.wa}?text=${encodeURIComponent(note)}`;
  const mailUrl = `mailto:${PREMIUM_SUPPORT.mail}?subject=${encodeURIComponent("Membresía Premium XIMA")}&body=${encodeURIComponent(note)}`;
  const isPremium = Boolean(access?.premium);

  return (
    <div className="xlm-root xpm-root">
      <ModernSidebar
        language={language}
        active="premium"
        badges={outletContext.sidebarBadges || {}}
        isAdmin={Boolean(outletContext.hasAdminMenuAccess)}
        actions={routeActions}
      />
      <div className="xlm-main">
        <header className="xlm-topbar">
          <div className="xlm-heading">
            <span>Más análisis, más videos y apoyo a XIMA</span>
            <h1>💎 Premium</h1>
          </div>
        </header>

        <section className="xpm-hero">
          <div className="xpm-price">
            <b>{PREMIUM_PRICE_USD} USD</b>
            <span>al mes</span>
          </div>
          <div className="xpm-hero-text">
            {isPremium ? (
              <>
                <strong className="xpm-badge">⭐ Ya eres Premium</strong>
                <p>Tienes análisis y videos sin límite. ¡Gracias por apoyar a XIMA!</p>
              </>
            ) : (
              <>
                <strong>Hazte miembro Premium</strong>
                <p>
                  {access && Number.isFinite(Number(access.remaining))
                    ? `Hoy te quedan ${access.remaining} análisis nuevos y ${Number(access.videosRemaining) || 0} ${
                        Number(access.videosRemaining) === 1 ? "video" : "videos"
                      } gratis.`
                    : "Analiza y descarga tus partidas sin límites."}
                </p>
              </>
            )}
            <a className="xpm-pay" href={PREMIUM_PAYPAL_URL} target="_blank" rel="noopener noreferrer">
              {isPremium ? "Pagar el próximo mes con PayPal" : `Pagar ${PREMIUM_PRICE_USD} USD con PayPal`}
            </a>
          </div>
        </section>

        <section className="xpm-benefits">
          {BENEFITS.map(([icon, title, text]) => (
            <div className="xpm-card" key={title}>
              <span className="xpm-icon" aria-hidden="true">{icon}</span>
              <strong>{title}</strong>
              <p>{text}</p>
            </div>
          ))}
        </section>

        <section className="xpm-card xpm-steps">
          <strong>Cómo activarlo</strong>
          <ol>
            {STEPS.map(([title, text]) => (
              <li key={title}>
                <b>{title}.</b> {text}
              </li>
            ))}
          </ol>
          <div className="xpm-contact">
            <a className="xpm-btn" href={waUrl} target="_blank" rel="noopener noreferrer">
              💬 WhatsApp {PREMIUM_SUPPORT.waShow}
            </a>
            <a className="xpm-btn" href={mailUrl}>
              ✉️ {PREMIUM_SUPPORT.mail}
            </a>
          </div>
          {userName ? (
            <p className="xpm-user">
              Tu usuario: <b>{userName}</b>
            </p>
          ) : null}
        </section>
      </div>
    </div>
  );
};

export default Premium;
